export const SET_COLOR_SCHEME = 'SET_COLOR_SCHEME'

export const setColorScheme = (index) => {
  return {
    type: SET_COLOR_SCHEME,
    index,
  }
}
